import moment from "moment";
import React from "react";
import { useState } from "react";
import { useAsync } from "react-async";
import RecentTimesheet from "../../../api/models/recentTimesheetModel";
import TimesheetProofingDebugResultModel from "../../../api/models/timesheetProofingDebugResult";
import { getDebugProofingRule } from "../../../api/services/proofingRulesService";
import { getRecentTimesheets } from "../../../api/services/timesheetService";
import DataTable, { Button } from "../../../components/dataTable";
import Select from 'react-select';
import { graySelectStyles } from '../../../common/selectStyles';

type Props = {
    ruleId: number,
    className?: string
}

const RuleDebugger = ({ ruleId, className }: Props) => {
    const [timesheetId, setTimesheetId] = useState<number>(-1);
    const [timesheets, setTimesheets] = useState<RecentTimesheet[]>();
    const [result, setResult] = useState<TimesheetProofingDebugResultModel>();

    //load the timesheet options
    useAsync({
        promiseFn: getRecentTimesheets,
        onResolve: (res) => {
            if (typeof res.data !== "undefined")
                setTimesheets(res.data);
        }
    });

    const entryColumns = React.useMemo(
        () => [
            {
                Header: 'Entry Id',
                accessor: 'timesheetEntryId',
            },
            {
                Header: 'District',
                accessor: 'districtName',
            },
            {
                Header: 'Entry Type',
                accessor: 'entryTypeName',
            },
            {
                Header: 'Task Type',
                accessor: 'taskTypeName',
            },
            {
                Header: 'Program',
                accessor: 'programName',
            },
            {
                Header: 'Minuets',
                accessor: 'minuets',
            },
            {
                Header: 'Bill To',
                accessor: 'billToName',
            },
            {
                Header: 'Status',
                accessor: 'studentStatus',
            },
            {
                Header: 'Grade',
                accessor: 'studentGrade',
            },
            {
                Header: 'Entry Date',
                accessor: (d: any) => moment(d.dateOfEntry).format("dddd MMMM Do"),
            },

        ],
        []
    );

    const timesheetSelected = async (timesheetId: number) => {
        setTimesheetId(timesheetId);

        if (timesheetId === -1) {
            setResult(undefined);
            return;
        }

        var res = await getDebugProofingRule(timesheetId, ruleId);
        if (typeof res.data !== "undefined")
            setResult(res.data);
    }
    console.log('render', result);
    return (
        <div className={className ?? ""}>
            <h2 className="text-center">Rule Debugger</h2>

            <div
                className="w-96 mx-auto">
                <label>
                    Select a timesheet to test (note: flags are not saved)
                    <Select
                        value={[
                            { value: -1, label: 'Select a timesheet' },
                            ...(timesheets?.sort((a, b) => a.disciplineName.localeCompare(b.disciplineName)).map(t => ({ value: t.timesheetId, label: `${t.disciplineName} - ${t.therapistLastName}, ${t.therapistFirstName} (${t.month}/${t.year}) [${t.entryCount}]` })) || [])
                        ].find(o => o.value === timesheetId) || null}
                        onChange={(selected) => { timesheetSelected(Number(selected?.value ?? -1)); }}
                        options={[
                            { value: -1, label: 'Select a timesheet' },
                            ...(timesheets?.sort((a, b) => a.disciplineName.localeCompare(b.disciplineName)).map(t => ({ value: t.timesheetId, label: `${t.disciplineName} - ${t.therapistLastName}, ${t.therapistFirstName} (${t.month}/${t.year}) [${t.entryCount}]` })) || [])
                        ]}
                        styles={graySelectStyles}
                    />
                </label>
            </div>

            {timesheetId !== -1 && (
                <div
                    className="mx-auto mt-2 w-20">
                    <Button
                        onClick={() => { timesheetSelected(timesheetId); }}>
                        Refresh
                    </Button>
                </div>
            )}

            {result && result.flaggedEntries && (
                <div>
                    {result.flaggedEntries.length > 0 && (
                        <DataTable
                            columns={entryColumns}
                            data={result.flaggedEntries}
                        />
                    )}

                    {result.flaggedEntries.length === 0 && (
                        <h1 className="text-center mt-10">No entries will be flagged from this timesheet</h1>
                    )}
                </div>
            )}

            {result && result.aggregationDebug && result.aggregationDebug.length > 0 && (
                <div className="text-center mt-10">
                    <h1>Aggregate Calculation Debugger. Sorted by aggregate and most recent weeks</h1>
                    <ul className="text-left">
                        {result.aggregationDebug.map(log => (
                            <li>{log}</li>
                        ))}
                    </ul>
                </div>
            )}

            {result && result.timesheetFlags && result.timesheetFlags.length > 0 && (
                <div className="text-center mt-10">
                    <h1>The selected timesheet returned the following flags</h1>
                    <ul>
                        {result.timesheetFlags.map(flag => (
                            <li>{flag.debugReason}</li>
                        ))}
                    </ul>
                </div>
            )}

            {result && (!result.timesheetFlags || result.timesheetFlags.length === 0) && (!result.flaggedEntries || result.flaggedEntries.length === 0) && (
                <h1 className="text-center mt-10 text-green-800">No flagged found on selected timesheet</h1>
            )}
        </div>
    );
}

export default RuleDebugger;